import React from "react";
import PropTypes from "prop-types";

import { useTrans } from "../../../hooks";
import {
  CURRENT_WATTYS_YEAR,
  DEFAULT_MILESTONES_LINK,
  MAP_MILESTONES_LINKS
} from "../ContestForm/constants";

const CompleteEligibleBanner = ({ formUrl, onOpenForm }) => {
  const { trans } = useTrans();
  const milestonesLink =
    MAP_MILESTONES_LINKS[parseInt(app.get("language"), 10)] ||
    DEFAULT_MILESTONES_LINK;

  return (
    <>
      <div className="text">
        {/* prettier-ignore */ trans("You made it! Your story is eligible for the %s Watty Awards.", CURRENT_WATTYS_YEAR)}
        <a
          className="plain-link bold"
          href={milestonesLink}
          target="_blank"
          rel="noopener noreferrer"
        >
          {trans("Find out more about the Wattys")}
        </a>
      </div>
      <a
        href={formUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="btn btn-white"
        onClick={onOpenForm}
      >
        <div className="btn-text">{trans("Enter the Wattys")}</div>
      </a>
    </>
  );
};

CompleteEligibleBanner.propTypes = {
  formUrl: PropTypes.string.isRequired,
  onOpenForm: PropTypes.func.isRequired
};

export default CompleteEligibleBanner;
